<template>
  <div v-if="page_loading">
    <!-- <LoadingDialog :page_loading="page_loading" /> -->


  </div>
  <div v-else>

    <div v-if="loadSucsess != false">
      <!-- <LoadingDialog :loading="loading" /> -->

      <v-card class="v-card-bottom-30 hidden-xs-only">
        <v-card-title class="py-5">
          <h4>Dashboard</h4> <v-icon>mdi-chevron-right</v-icon><span class="font-weight-regular body-1">{{
            use_language.navigat_title }}</span>
          <v-spacer />
        </v-card-title>
      </v-card>

      <v-card elevation="1" class="v-card-margin-bottom-30" v-if="announceDataTable.length != 0">
        <v-card-title>
          <v-icon size="22" color="primary">fa-bullhorn</v-icon>
          <span class="ml-3">{{ use_language.announcement }}</span>
        </v-card-title>
        <v-card-text>
          <v-data-table :headers="announceHeaders" :items="announceDataTable" class="elevation-0 packhai-border-table"
            hide-default-footer style="min-height: auto" :items-per-page="9999999999" :mobile-breakpoint="0">
            <template v-slot:item.startDate="{ item }">
              <span>{{ item.startDate }} - {{ item.endDate }}</span>
            </template>
            <template v-slot:item.photoLink="{ item }">
              <v-img v-if="item.photoLink != null" class="my-1 justify-center" max-width="80px" :src="item.photoLink"
                @click="OpenPhoto(item.photoLink)" />
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- ส่วนที่ 1  -->
      <v-row justify="start" align="center" class="my-7 margin-card-status">
        <v-col cols="12" sm="12" md="12" lg="4" align="left">
          <v-card dark color="teal" style="height: 175px;">
            <v-card-title>
              <!-- ยอดขายวันนี้ -->
              {{ use_language.card1_head }}
            </v-card-title>
            <v-divider />
            <v-card-text style="height : 135px;">
              <!-- <v-row >
                  <v-col cols="12" align="left" class="pa-0 ma-0">
                    <img src="@/assets/icon_jpg/i1.jpg"  style="width: 40px" />
                  </v-col>
                </v-row> -->
              <v-row>
                <v-col cols="2" xl="1" align="center" class="pa-0 ma-0">
                  <img src="@/assets/icon_jpg/i1.jpg" style="width: 40px" />
                </v-col>
                <v-col cols="10" xl="11" align="center" class="pt-8">
                  <h1> ฿ <span>{{ sum_today_salse }}</span> {{ use_language.currency }}</h1>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" align="left">
          <v-card dark color="primary" style="height: 175px;">
            <v-card-title>
              <!-- ยอดขาย อาทิตย์นี้ -->
              {{ use_language.card2_head }}
            </v-card-title>
            <v-divider />
            <v-card-text style="height : 135px;">
              <!-- <v-row >
                  <v-col cols="12" align="left" class="pa-0 ma-0">
                    <img src="@/assets/icon_jpg/i2.jpg"  style="width: 40px" />
                  </v-col>
                </v-row> -->
              <v-row>
                <v-col cols="2" xl="1" align="center" class="pa-0 ma-0">
                  <img src="@/assets/icon_jpg/i2.jpg" style="width: 40px" />
                </v-col>
                <v-col cols="10" xl="11" align="center">
                  <h1> ฿ <span>{{ sum_thisweek_salse }}</span> {{ use_language.currency }}</h1><br><br>
                  <h3> {{ use_language.card2_title }} ฿ {{ sum_lastweek_salse }} {{ use_language.currency }}</h3>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" align="left">
          <v-card dark color="warning" style="height: 175px;">
            <v-card-title>
              <!-- ยอดขายเดือนนี้ -->
              {{ use_language.card3_head }}
            </v-card-title>
            <v-divider />
            <v-card-text style="height : 135px;">
              <!-- <v-row >
                  <v-col cols="12" align="left" class="pa-0 ma-0">
                    <img src="@/assets/icon_jpg/i3.jpg"  style="width: 40px" />
                  </v-col>
                </v-row> -->
              <v-row>
                <v-col cols="2" xl="1" align="center" class="pa-0 ma-0">
                  <img src="@/assets/icon_jpg/i3.jpg" style="width: 40px" />
                </v-col>
                <v-col cols="10" xl="11" align="center" class="pt-8">
                  <h1> ฿ <span>{{ sum_this_month_salse }}</span> {{ use_language.currency }}</h1>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- ส่วนที่ 2  -->

      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title class="py-4">
          <v-icon size="20" color="success">fa-chart-area</v-icon> <span class="ml-3">{{ use_language.graph_line1_head
          }}</span>
          <v-select class="ml-1" v-model="select_year_to_this_year_items"
            @change="get_monthly_sale(select_year_to_this_year_items)" :items="year_to_this_year_items" dense
            hide-details outlined style="max-width: 100px!important; font-size: 16.5px !important;"
            color="false"></v-select>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text style="min-height: 350px;">
          <GChart type="LineChart" :data="chartData" :options="chartOptions" max-width="100%" />
        </v-card-text>
      </v-card>

      <v-row class="mx-0 px-0">
        <v-col class="px-0" cols="12" md="6">
          <v-card elevation="1" class="v-card-bottom-30 margin-card-r-3">
            <v-card-title class="py-4">
              <v-icon size="20" color="success">fa-chart-area</v-icon> <span class="ml-3">{{
                use_language.graph_pie1_head }}</span>
              <v-spacer />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <GChart type="PieChart" :settings="{ packages: ['corechart'] }" :data="chartPieData_chanal_price"
                :options="chartPieOptions_chanal_price.chart"></GChart>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="px-0" cols="12" md="6">
          <v-card elevation="1" class="v-card-bottom-30 margin-card-l-3">
            <v-card-title class="py-4">
              <v-icon size="20" color="success">fa-chart-area</v-icon> <span class="ml-3">{{
                use_language.graph_pie2_head }}</span>
              <v-spacer />
            </v-card-title>
            <v-divider />
            <v-card-text>
              <GChart type="PieChart" :settings="{ packages: ['corechart'] }" :data="chartPieData_admin_price"
                :options="chartPieOptions_admin_price.chart" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mx-0 px-0">
        <v-col class="px-0" cols="12" md="6">
          <v-card elevation="1" class="v-card-bottom-30 margin-card-r-3">
            <v-card-title class="py-4">
              <v-icon size="20" color="info darken-3">fa-chart-bar</v-icon> <span class="ml-3">{{
                use_language.card_table1_head }} </span>
              <v-spacer />
              <v-btn @click="to_report_page('admin')" outlined color="info">{{ use_language.button_more }}</v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text style="min-height: 400px; max-height: 400px; overflow-y : auto ;">
              <!-- pc salse -->
              <v-data-table :headers="[
                { text: use_language.no_2, align: 'center', value: 'no', width: '60px', sortable: false },
                { text: use_language.picture_, align: 'center', value: 'staffImage', width: '30px', sortable: false },
                { text: use_language.saleman_name, align: 'start', value: 'staffName', sortable: false },
                { text: use_language.order_count, align: 'end', value: 'countOrder', width: '110px', sortable: false },
                { text: use_language.total_price, align: 'end', value: 'totalSale', width: '100px', sortable: false },
              ]" :items="today_admin_list" item-key="name" class="elevation-0 packhai-border-table" hide-default-footer
                mobile-breakpoint="0" :items-per-page="1000000">
                <template v-slot:item.no="{ item }">
                  {{ item.no + 1 }}
                </template>
                <template v-slot:item.staffImage="{ item }">
                  <v-avatar size="25px" v-if="item.staffImage">
                    <img :src="item.staffImage" @click="OpenPhoto(item.staffImage)" />
                  </v-avatar>
                </template>

              </v-data-table>
            </v-card-text>
            <!-- <v-card-actions>
                <v-spacer/>
                <v-btn text @click="to_report_page('admin')" color="info">{{ use_language.button_more }} >>></v-btn>
              </v-card-actions> -->
          </v-card>
        </v-col>
        <v-col class="px-0" cols="12" md="6">
          <v-card elevation="1" class="v-card-bottom-30 margin-card-l-3">
            <v-card-title class="py-4">
              <v-icon size="20" color="info darken-3">fa-chart-bar</v-icon>
              <span class="ml-3">{{ use_language.card_table2_head }} </span>
              <v-spacer />
              <v-btn @click="to_report_page('product')" outlined color="info">{{ use_language.button_more }}</v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text style="min-height: 400px; max-height: 400px; overflow-y : auto ;">
              <!-- pc product -->
              <v-data-table :headers="[
                { text: use_language.no_2, align: 'center', value: 'no', width: '60px', sortable: false },
                { text: use_language.picture_, align: 'center', value: 'productUrl', width: '60px', sortable: false },
                { text: use_language.product_name, align: 'start', value: 'productName', sortable: false },
                { text: use_language.piece_count, align: 'end', value: 'totalQuantity',width: '110px', sortable: false },
                { text: use_language.total_price, align: 'end', value: 'totalSale', width: '100px', sortable: false },
              ]" :items="today_product_list" item-key="name" class="elevation-0 packhai-border-table"
                hide-default-footer mobile-breakpoint="0" :items-per-page="1000000">
                <template v-slot:item.no="{ item }">
                  {{ item.no + 1 }}
                </template>
                <template v-slot:item.productUrl="{ item }">
                  <a v-if="item.productUrl" @click="OpenPhoto(item.productUrl)">
                    <img :src="item.productUrl" style="width: 60px; height: 60px;">
                  </a> 
                </template>
                 <template v-slot:item.productName="{ item }">
                   <v-row>
                  <v-col cols="12" align="left" class="pa-0">
                    <span class="fn-13" style="font-weight: bold">{{
                      item.productName
                    }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" align="left" class="pa-0">
                    <span  style="color: gray;">
                      {{!item.sku ? "" :    "SKU : "+item.sku}} {{!item.barcode ? "" : ((item.sku)?", ":"") + use_language.barcode+ " : "+item.barcode}}
                    </span>
                  </v-col>

                </v-row>

                <v-row>
                  <v-col cols="12" align="left" class="pa-0">
                    <span class="color-gray-13"> 
                        {{!item.prop1Description ? "" : item.prop1Description}} {{!item.prop2Description ? "" : ", "+item.prop1Description}}
                    </span>
                  </v-col>

                </v-row>

                </template>
              </v-data-table>
            </v-card-text>
            <!-- <v-card-actions>
                <v-spacer/>
                <v-btn text @click="to_report_page('product')" color="info" >{{ use_language.button_more }} >>></v-btn>
              </v-card-actions> -->
          </v-card>
        </v-col>
      </v-row>


      <v-row class="mx-0 px-0">
        <v-col class="px-0" cols="12" md="6">
          <v-card elevation="1" class="v-card-bottom-30 margin-card-r-3">
            <v-card-title class="py-4">
              <v-icon size="20" color="primary darken-3">fa-chart-bar</v-icon> <span class="ml-3">{{
                use_language.card_table3_head }} </span>
              <v-spacer />
              <v-btn @click="to_report_page('admin')" outlined color="info">{{ use_language.button_more }}</v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text style="min-height: 400px; max-height: 400px; overflow-y : auto ;">
              <!-- pc salse -->
              <v-data-table :headers="[
                { text: use_language.no_2, align: 'center', value: 'no', width: '60px', sortable: false },
                { text: use_language.picture_, align: 'center', value: 'staffImage', width: '30px', sortable: false },
                { text: use_language.saleman_name, align: 'start', value: 'staffName', sortable: false },
                { text: use_language.order_count, align: 'end', value: 'countOrder', width: '110px', sortable: false },
                { text: use_language.total_price, align: 'end', value: 'totalSale', width: '100px', sortable: false },
              ]" :items="rs_admin_salse" item-key="name" class="elevation-0 packhai-border-table" hide-default-footer
                mobile-breakpoint="0" :items-per-page="1000000">
                <template v-slot:item.no="{ item }">
                  {{ item.no + 1 }}
                </template>
                <template v-slot:item.staffImage="{ item }">
                  <v-avatar size="25px" v-if="item.staffImage">
                    <img :src="item.staffImage" @click="OpenPhoto(item.staffImage)" />
                  </v-avatar>
                </template>
              </v-data-table>
            </v-card-text>
            <!-- <v-card-actions>
                <v-spacer/>
                <v-btn text @click="to_report_page('admin')" color="info">{{ use_language.button_more }} >>></v-btn>
              </v-card-actions> -->
          </v-card>
        </v-col>
        <v-col class="px-0" cols="12" md="6">
          <v-card elevation="1" class="v-card-bottom-30 margin-card-l-3">
            <v-card-title class="py-4">
              <v-icon size="20" color="primary darken-3">fa-chart-bar</v-icon>
              <span class="ml-3">{{ use_language.card_table4_head }} </span>
              <v-spacer />
              <v-btn @click="to_report_page('product')" outlined color="info">{{ use_language.button_more }}</v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text style="min-height: 400px; max-height: 400px; overflow-y : auto ;">
              <!-- pc product -->
              <v-data-table :headers="[
                 { text: use_language.no_2, align: 'center', value: 'no', width: '60px', sortable: false },
                { text: use_language.picture_, align: 'center', value: 'productUrl', width: '60px', sortable: false },
                { text: use_language.product_name, align: 'start', value: 'productName', sortable: false },
                { text: use_language.piece_count, align: 'end', value: 'totalQuantity',width: '110px', sortable: false },
                { text: use_language.total_price, align: 'end', value: 'totalSale', width: '100px', sortable: false },
              ]" :items="rs_products_salse" item-key="name" class="elevation-0 packhai-border-table"
                hide-default-footer mobile-breakpoint="0" :items-per-page="1000000">
                <template v-slot:item.no="{ item }">
                  {{ item.no + 1 }}
                </template>
                   <template v-slot:item.productUrl="{ item }">
                  <a v-if="item.productUrl" @click="OpenPhoto(item.productUrl)">
                    <img :src="item.productUrl" style="width: 60px; height: 60px;">
                  </a> 
                </template>
                 <template v-slot:item.productName="{ item }">
                   <v-row>
                  <v-col cols="12" align="left" class="pa-0">
                    <span class="fn-13" style="font-weight: bold">{{
                      item.productName
                    }}</span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" align="left" class="pa-0">
                    <span  style="color: gray;">
                      {{!item.sku ? "" :    "SKU : "+item.sku}} {{!item.barcode ? "" : ((item.sku)?", ":"") + use_language.barcode+ " : "+item.barcode}}
                    </span>
                  </v-col>

                </v-row>

                <v-row>
                  <v-col cols="12" align="left" class="pa-0">
                    <span class="color-gray-13"> 
                        {{!item.prop1Description ? "" : item.prop1Description}} {{!item.prop2Description ? "" : ", "+item.prop1Description}}
                    </span>
                  </v-col>

                </v-row>

                </template>
              </v-data-table>
            </v-card-text>
            <!-- <v-card-actions>
                <v-spacer/>
                <v-btn text @click="to_report_page('product')" color="info" >{{ use_language.button_more }} >>></v-btn>
              </v-card-actions> -->
          </v-card>
        </v-col>
      </v-row>

    </div>

    <div v-else style="max-height : 600px; padding-top: 300px;" class="px-5" align="center">
      <span style="color: orange">Loading</span><br><br>
      <v-progress-circular indeterminate color="yellow darken-2"></v-progress-circular>
    </div>

    <v-dialog transition="dialog-top-transition" max-width="800" v-model="dialog_promotion">
      <template v-slot:default="dialog">
        <v-card>
          <div class="text-h2 pa-12" style="font-family: 'Kanit' !important, sans-serif !important;">
            <b>{{ use_language.today_promotion }}!</b>
          </div>
          <v-card-text style="height: 500px" class="overflow-y-auto">

            <div v-for="item in data_promotion_list" :key="item.id">
              <v-row>
                <v-col cols="12" md="5">
                  <v-card class="pa-2">
                    <v-img :src="item.image" max-height="125"></v-img>
                  </v-card>
                </v-col>
                <v-col cols="12" md="7">
                  <v-card style="height: 141px" class="pa-5 overflow-y-auto">
                    <span style="font-size: 18px; font-family: 'Kanit', sans-serif; font-weight:bold;">{{ item.title
                    }}</span><br>
                    <span style="font-size: 14px; font-family: 'Kanit', sans-serif;">{{ item.info }}</span>
                    <div style="font-size: 14px; font-family: 'Kanit', sans-serif;">
                      <v-btn text color="primary" class="px-0" @click="to_url(item)">{{ use_language.read_more }}</v-btn>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-divider />
            </div>

          </v-card-text>
          <v-card-actions class="justify-end">
            <!-- <v-btn
                text
                @click="dialog.value = false"
              >Close</v-btn> -->
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- ประกาศ -->
    <v-dialog transition="dialog-top-transition" max-width="800" v-model="dialog_announce">
      <template v-slot:default="dialog">
        <v-card>
          <div class="text-h4 px-12 py-7 text-center">
            <v-icon size="33" color="primary">fa-bullhorn</v-icon>
            <span class="pl-2" style="font-family: 'Kanit' !important, sans-serif !important;">
              {{ use_language.announce_from }}{{ announceDataPopup.announceFrom }} !
            </span>
          </div>
          <v-card-text style="height: 500px" class="overflow-y-auto">

            <v-row>
              <v-col v-if="announceDataPopup.photoLink != null" cols="12" class="text-center">
                <v-img :src="announceDataPopup.photoLink" max-width="400" class="mx-auto"></v-img>
              </v-col>
              <v-col cols="12">
                <span style="font-size: 18px; font-family: 'Kanit', sans-serif; font-weight:bold;">
                  {{ use_language.announce_subject_label }} {{ announceDataPopup.subject }}
                </span>
                <br>
                <template v-if="announceDataPopup.isMarketplaceExpire">
                  <div v-for="(line, index) in announceDescriptionLines" :key="index"
                    :class="index == announceDescriptionLines.length - 1 ? 'text-center' : 'pl-5'"
                    style="font-size: 14px; font-family: 'Kanit', sans-serif;">
                    {{ line }}
                  </div>
                </template>
                <span v-else class="pl-5"
                  style="font-size: 14px; font-family: 'Kanit', sans-serif; white-space: pre-line;">
                  {{ announceDataPopup.description }}
                </span>
              </v-col>
              <!-- <v-col v-if="announceDataPopup.isMarketplaceExpire" cols="12" class="text-center">
                <v-btn color="primary" @click="$router.push('/connect')">
                  <v-icon size="16" class="pr-2">fa-link</v-icon>
                  ไปหน้าเชื่อมต่อ
                </v-btn>
              </v-col> -->
            </v-row>
          </v-card-text>

          <v-card-actions class="check-center">
            <div class="d-flex">
              <v-checkbox v-model="announceDataPopup.isHide" @change="hideAnnounce"></v-checkbox>
              <span>{{ use_language.do_not_show_this_message_again }}</span>
            </div>
          </v-card-actions>

          <v-divider class="" />
          <v-card-actions>
            <v-row>
              <v-col>
                <v-btn text @click="announceCount--, viewAnnounce()" :disabled="announceCount <= 1">{{ use_language.back }}</v-btn>
              </v-col>
              <v-col class="text-center" align-self="center">
                <div class="h3">{{ announceCount }} / {{ announceList.length }}</div>
              </v-col>
              <v-col class="text-right">
                <v-btn v-if="announceCount == announceList.length" text @click="dialog_announce = false">{{ use_language.close }}</v-btn>
                <v-btn v-if="announceCount < announceList.length" @click="announceCount++, viewAnnounce()">{{ use_language.next }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog transition="dialog-top-transition" max-width="800" v-model="dialog_changepassword">
      <v-card>
        <v-card-title>
          {{ use_language.please_change_password }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px" class="overflow-y-auto">

          <v-row>
            <v-col cols="12" class="pt-1 pb-2">
              {{ use_language.password_90_days_warning }}
            </v-col>
          </v-row>
          <!-- <v-row>
                <v-col cols="12" md="3" class="pt-1 pb-2">
                  <span class="fn-14">  รหัสผ่านเก่า : </span>
                </v-col>
                <v-col cols="12" md="9" class="pt-1 pb-2">
                  <v-text-field
             
                    ref="staffShoppassword"
                   
                    autocomplete="off"
                    outlined
                    dense hide-details
                    :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show_password ? 'text' : 'password'"
                    @click:append="show_password = !show_password"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3" class="pt-1 pb-2">
                  <span class="fn-14">  {{use_language.password}} : </span>
                </v-col>
                <v-col cols="12" md="9" class="pt-1 pb-2">
                  <v-text-field
                    
                    ref="staffShoppassword"
                   
                    autocomplete="off"
                    outlined
                    dense hide-details
                    :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show_password ? 'text' : 'password'"
                    @click:append="show_password = !show_password"
                  ></v-text-field>
                </v-col>
              </v-row> -->

          <!-- <v-row>
                <v-col cols="12" md="3" class="pt-1 pb-2">
                  <span class="fn-14"> {{use_language.confirm_password}} : </span>
                </v-col>
                <v-col cols="12" md="9" class="pt-1 pb-2">
                  <v-text-field
                    
                    ref="staffShoppassword2"
                  
                    autocomplete="off"
                    outlined
                    dense hide-details
                    :append-icon="show_password2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show_password2 ? 'text' : 'password'"
                    @click:append="show_password2 = !show_password2"
                  ></v-text-field>
                </v-col>
              </v-row> -->
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn primary>{{ use_language.button_save }}</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
    <div>
      <firsttimedialog v-if="IsShowSetupDialog && branchID !== 301" />
    </div>

    <Photo v-if="ShowPhoto" :showphoto="ShowPhoto" :showphotolink="ShowPhotoLink" @emitshowphoto="ClosePhoto" />
  </div>
</template>

<script>
//import LoadingDialog from '@/website/components/Loading'
import firsttimedialog from '@/website/components/firsttimedialog'
import VueGoogleCharts from 'vue-google-charts'
import { GChart } from 'vue-google-charts'
import axios from 'axios'
import { generalService_dotnet, reportService_dotnet, branchService_dotnet, shopService_dotnet } from '@/website/global'
import { format_number, format_order_id, format_price, get_languages, getPostcodeMapping } from '@/website/global_function'
import Photo from "@/website/components/photo";
import { dashboard_language } from "@/website/language/dashboard_language";

export default {
  components: {
    firsttimedialog,
    //LoadingDialog,
    GChart,
    // 'barcode': VueBarcode
    Photo,
  },

  data: () => ({
    page_loading: true,
    loading: false,
    loadSucsess: false,
    IsShowSetupDialog: false,
    branchID: null,
    use_language: null,
    set_language: null,

    // selectChartYear

    select_year_to_this_year_items: null,
    year_to_this_year_items: [],
    dialog_changepassword: false,
    lastlogin: null,


    // headers_admin: [
    //   { text: 'ลำดับ',   align: 'center',   value: 'no', width: '5%', sortable: false },
    //   { text: 'ชื่อ',   align: 'start',   value: 'staffName', width: '60%', sortable: false },
    //   { text: 'จำนวนออเดอร์',   align: 'end', value: 'countOrder', width: '35%', sortable: false },
    //   { text: 'ยอดขาย',   align: 'end', value: 'totalSale', width: '35%', sortable: false },
    // ],

    // headers_product: [
    //   { text: 'ลำดับ',   align: 'center',   value: 'no', width: '5%', sortable: false },
    //   { text: 'สินค้า',   align: 'start',   value: 'productName',  width: '45%', sortable: false },
    //   { text: 'จำนวน',   align: 'end', value: 'totalQuantity',  width: '25%', sortable: false },
    //   { text: 'ยอดขาย',   align: 'end', value: 'totalSale',  width: '25%', sortable: false },
    // ],

    today_admin_list: [],
    today_product_list: [],

    chartData: [
      ['month', 'Sales'],
      ['January', 0],
      ['February', 0],
      ['March', 0],
      ['April', 0],
      ['May', 0],
      ['June', 0],
      ['July', 0],
      ['August', 0],
      ['September', 0],
      ['October', 0],
      ['November', 0],
      ['December', 0],
    ],


    chartOptions: {
      chart: {
        title: 'Company Performance',
        subtitle: 'Sales, Expenses, and Profit: 2014-2017',
      }
    },

    // param Dashboard_shop_salse
    sum_today_salse: 0,
    sum_thisweek_salse: 0,
    sum_lastweek_salse: 0,
    sum_this_month_salse: 0,

    // param Dashboard_admin_salse
    rs_admin_salse: null,
    rs_products_salse: null,


    // กราฟวงกลม chanal price
    chartPieData_chanal_price: [],

    chartPieOptions_chanal_price: {
      chart: {
        // title: "ยอดขายตามช่องทางการขาย",
        pieHole: 10.4,
        width: '100%',
        height: 450,
        legend: { position: 'bottom' }
      }
    },

    // กราฟวงกลม admin price
    chartPieData_admin_price: [],

    chartPieOptions_admin_price: {
      chart: {
        // title: "ยอดขายตามแอดมิน",
        pieHole: 10.4,
        width: '100%',
        height: 450,
        legend: { position: 'bottom' }
      }
    },

    dialog_promotion: false,
    data_promotion_list: [],
    header_token: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('authorization_token') },

    //announce
    announceDataTable: [],

    dialog_announce: false,
    announceList: [],
    announceDataPopup: null,
    announceCount: 1,

    // แสดงภาพ
    ShowPhoto: false,
    ShowPhotoLink: null,
  }),

  computed: {
    announceHeaders() {
      return [
        { text: this.use_language.announce_date, align: 'center', sortable: false, value: 'startDate', width: '200px' },
        { text: this.use_language.announce_subject, align: 'center', sortable: false, value: 'subject', width: '200px' },
        { text: this.use_language.details, align: 'left', sortable: false, value: 'description', width: '500px' },
        { text: this.use_language.picture, align: 'center', sortable: false, value: 'photoLink', width: '20px' },
        { text: this.use_language.announce_from, align: 'center', sortable: false, value: 'announceFrom', width: '100px' },
      ]
    },
    // computed_search_date() {
    //   return this.formatDate(this.search_date_range)
    // },

    announceDescriptionLines() {
      if (this.announceDataPopup == null || this.announceDataPopup.description == null) { return [] }
      return this.announceDataPopup.description.split(/\r?\n/)
    },
  },

  async created() {


    //เก็บภาษามาไว้ใน use_language


    this.use_language = await this.get_languages();

    this.menuCode100 = localStorage.getItem("100") //หน้าแรก
    if (this.menuCode100 == 'null') {
      this.$router.push('/order')
    }
    this.branchID = parseInt(localStorage.getItem("branch_id")),


      this.page_loading = false
    await this.get_staffshop_only()
    await this.set_date()
    await this.get_data_promotions()
    await this.getAnnounceShow()
    // await this.get_data_dash_borad_page()


    var thisYear = new Date().getFullYear()

    this.get_shop_dashboard(thisYear)
    this.get_monthly_sale(thisYear)
    // this.get_today_sale(thisYear)

    this.postcode_mapping = await this.getPostcodeMapping();


  },

  methods: {
    get_languages,
    getPostcodeMapping,
    format_number,
    format_order_id,
    format_price,

    async getAnnounceShow() {
      let response = await axios.post(
        generalService_dotnet + 'Announce/get-announce-shop',
        {
          "shopID": parseInt(localStorage.getItem("shop_id")),
          "staffID": parseInt(localStorage.getItem('staff_id'))
        },
        { headers: this.header_token }
      )
      if (response.status == 200) {
        this.announceDataTable = response.data.forTable
        this.announceList = response.data.forPopup
        this.announceDataPopup = this.announceList[0]
        if (this.announceList.length > 0) {
          this.dialog_announce = true
        }
      }
    },
    async viewAnnounce() {
      var count = await this.announceCount - 1
      this.announceDataPopup = this.announceList[count]
    },
    async hideAnnounce() {
      let response = await axios.post(
        generalService_dotnet + 'Announce/hide-announce-shop',
        {
          "annoucneID": this.announceDataPopup.id,
          "shopID": parseInt(localStorage.getItem("shop_id")),
          "staffID": parseInt(localStorage.getItem('staff_id')),
          "type": this.announceDataPopup.announceType
        },
        { headers: this.header_token }
      )
    },
    OpenPhoto(Photo) {
      this.ShowPhotoLink = Photo
      this.ShowPhoto = true
    },
    ClosePhoto(value) {
      this.ShowPhoto = value;
      this.ShowPhotoLink = null;
    },

    // allowedDates: val => val <= new Date().toISOString().substr(0, 10),
    setZero(data) {
      if (parseInt(data) < 10) {
        return '0' + data
      } else {
        return data
      }
    },

    get_shop_dashboard(year) {
      axios.post(reportService_dotnet + 'Report/shop-dashboard', {
        "shopID": localStorage.getItem("shop_id"),
        "year": year
      },
        { headers: this.header_token }).then((response) => {

          this.sum_lastweek_salse = response.data.lastWeekTotalSale
          this.sum_thisweek_salse = response.data.thisWeekTotalSale

          this.sum_this_month_salse = response.data.thisMonthTotalSale

          this.rs_admin_salse = response.data.adminSaleTableResponse
          this.rs_products_salse = response.data.productSaleTableResponse

          this.chartPieData_admin_price = response.data.pie_admin
          this.chartPieData_chanal_price = response.data.pie_channel

          this.sum_today_salse = response.data.todayTotalSale

          this.today_admin_list = response.data.todayAdminSaleTableResponse
          this.today_product_list = response.data.todayProductSaleTableResponse

          this.loadSucsess = true

        })
    },

    get_monthly_sale(year) {
      axios.post(reportService_dotnet + 'Report/monthly-sale', {
        "shopID": localStorage.getItem("shop_id"),
        "year": year
      },
        { headers: this.header_token }).then((response) => {
          this.chartData = response.data.graph_sale

        })
    },

    gen_firt_and_last_day_for_munth(date) {

      date = new Date(date)
      var fd = new Date(date.getFullYear(), date.getMonth(), 1);
      var ld = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      this.firstDay = fd.getFullYear().toString() + '-' + this.setZero(fd.getMonth() + 1).toString() + '-' + this.setZero(fd.getDate())
      this.lastDay = ld.getFullYear().toString() + '-' + this.setZero(ld.getMonth() + 1).toString() + '-' + this.setZero(ld.getDate())
      return [this.firstDay + ' 00:00:00', this.lastDay + ' 23:59:59']
    },

    set_date() {

      // set data to year_to_this_year_items
      var date_year_select = new Date()
      this.date_year_select = date_year_select.getFullYear().toString()
      for (var y = 2019; y <= parseInt(this.date_year_select); y++) {
        this.year_to_this_year_items.push({
          text: y.toString(),
          value: y.toString()
        });
      }

      // set defal select data
      var date_select = new Date();
      var year_for_select = date_select.getFullYear();
      this.select_year_to_this_year_items = year_for_select.toString()


    },

    to_report_page(type) {
      if (type == 'admin') {
        window.open("report-sales1");
      } else {

        window.open("dashboard_best_sale_product");
      }
    },



    async get_data_promotions() {

      let res1 = await axios.post(branchService_dotnet + 'Branch/get-new-promotions-branch', {
        "branchID": localStorage.getItem("branch_id"),
        "shopID": localStorage.getItem("shop_id"),
      }, { headers: this.header_token })
      this.data_promotion_list = res1.data
      // if(res1.data.length > 0){
      //   this.dialog_promotion = true
      // }
    },
    async get_staffshop_only() {
      await axios.post(shopService_dotnet + 'StaffShop/get-staffshop-only-by-staffid', {
        "id": localStorage.getItem('staff_id'),
      }, { headers: this.header_token }).then((res) => {
        this.lastlogin = res.data.lastLoginDate
        if (this.lastlogin == null) {
          this.IsShowSetupDialog = true;
        }
      }).catch((error) => { });

    },

    to_url(item) {
      window.open(item.url)
    },

  }
}
</script>
<style scoped>
/* >>>.v-dialog {
        -webkit-box-shadow: none;
        box-shadow: none;
    } */
.check-center {
  justify-content: center;
}

>>>.bex48-logo {
  width: 12.533vw;
  height: 11.2vw;
  display: block;
  /* margin: 8.8vw auto 1.6vw; */
  margin: 1.6vw auto 1.6vw;
}

>>>.slide-fade-enter-active {
  transition: all .3s ease;
}

>>>.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

>>>.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateY(10px);
  opacity: 0;
}

.packhai-border-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.packhai-border-table thead {
  color: white;
}

.packhai-border-table thead tr th {

  font-weight: bold;
  font-size: 1rem;
}

.return-order-table {
  width: 100%;
}

.padding-for-order-dialog {
  padding: 0px !important;
}

>>>.margin-card-r-10 {
  margin-right: 0px;
}

>>>.margin-card-l-10 {
  margin-left: 0px;
}

@media screen and (min-width: 768px) {
  .return-order-table {
    width: 300px;
  }

  .padding-for-order-dialog {
    padding: 15px !important;
  }

  .margin-card-r-3 {
    margin-right: 10px;
  }

  .margin-card-l-3 {
    margin-left: 10px;
  }
}

.packhai-border-preview {
  border-top: solid 1px black;
  border-left: solid 1px black;
  border-right: solid 1px black;
  border-bottom: solid 1px black;
  border-radius: 10px;
}

.px-15 {
  padding-left: 15px;
  padding-right: 15px;
}

.fz-12 {
  font-size: 12px !important;
}

.fz-14 {
  font-size: 14px !important;
}
</style>
